import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banned',
  templateUrl: './banned.component.html',
  styleUrls: ['./banned.component.css']
})
export class BannedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
